import React from 'react'
import { Link } from 'react-router-dom'

function MealSubscription() {
  return (
    <>
      {/* Inner Banner Section */}
      <section className="inner-banner">
        <div
          className="image-layer"
          style={{ backgroundImage: "url(assets/images/coimbatore-homemade-food-banner.jpg)" }}
        />
        <div className="auto-container">
          <div className="inner">
            <h1>Meal Subscription</h1>
            <div className="sub_text">
              <p>
                Home - <a href="" className="primary-color">Meal Subscription</a>
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* End Banner Section */}

      {/* Story Section */}
      <section className="story-section section-kt">
        <div className="auto-container">
          <div className="title-box">
            <div className="subtitle"><span>Tickling Tummy</span></div>

            <h2>
              <span className="theme_color">Meal Subscription</span> — Hassle-Free
              Home-Cooked Veg Meals Daily in Coimbatore
            </h2>
          </div>

          <div className="row clearfix">
            <div className="text-col col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center">
              <p>
                Too busy to check our daily specials or pre-order every day? Simplify your meals with
                Tickling Tummy’s subscription plans. Whether you’re craving breakfast, lunch, dinner, or any
                combo, we’ve got you covered—weekly or monthly—with pickup or delivery at an additional cost
                right from our R.S. Puram kitchen.
                <br />
                <br />
                No surprises, no stress. Just wholesome, Amma-style vegetarian meals made fresh each day.
                Choose your plan, tell us your preferences, and leave the rest to us. Perfect for working
                professionals, families, senior citizens, or anyone who just wants one less thing to worry
                about.
                <br />
                <br />
                We deliver across R.S. Puram, Avinashi Road, Ganapathy, Gandhi Park, Gandhipuram,
                Koundampalayam, Ponyarajpuram, Race Course, Ram Nagar, Saibaba Colony, Saravanampatti,
                Sulur, Thudiyalur, Trichy Road, Vadavalli and more — perfect for working professionals,
                families, or senior citizens who want one less thing to worry about.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section" style={{ padding: "60px 0" }}>
        <div className="container">
          {/* First Row - Image Left, Content Right */}
          <div className="row" style={{ alignItems: "center", marginBottom: "60px" }}>
            <div className="col-lg-6 col-md-12">
              <div className="image-box">
                <img src="assets/images/meal-subscription-packaging.jpg" alt="How it works image" className="img-fluid" />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="content-box">
                <div className="sec-title">
                  <h2>How It Works</h2>
                </div>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                  <li>
                    ◆ Ping us on WhatsApp (<a href="https://wa.me/+91-9385000111" target="_blank" rel="noreferrer">+91-9385000111</a>)
                  </li>
                  <li>◆ Tell us which meal you want (Breakfast, lunch & dinner, or any single meal)</li>
                  <li>◆ We’ll send meal plan options</li>
                  <li>◆ Choose weekly or monthly</li>
                  <li>◆ Pick up from R.S. Puram, or choose delivery (third-party logistics at extra cost)</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Second Row - Content Left, Image Right */}
          <div className="row" style={{ alignItems: "center", flexDirection: "row-reverse" }}>
            <div className="col-lg-6 col-md-12">
              <div className="image-box">
                <img src="assets/images/healthy-lunch-box-delivery-coimbatore.jpg" alt="Subscription image" className="img-fluid" />
              </div>
            </div>

            <div className="col-lg-6 col-md-12">
              <div className="content-box">
                <div className="sec-title">
                  <h2>Subscribing Made Simple</h2>
                </div>
                <p>With a subscription, you never have to think about cooking.</p>
                <p>It’s perfect if you:</p>
                <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                  <li>◆ Work long hours and lose track of time</li>
                  <li>◆ Want regular, healthy meals for seniors or kids</li>
                  <li>◆ Prefer budget-friendly, yet wholesome food</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Schema for Meal Subscriptions */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Which areas in Coimbatore do you deliver meal subscriptions to?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We deliver across major areas including R.S. Puram, Race Course, Saibaba Colony, Gandhipuram, Avinashi Road, and Saravanampatti."
              }
            },
            {
              "@type": "Question",
              "name": "How do I start a monthly tiffin service?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "You can start by contacting us on WhatsApp (+91 9385000111). We'll share the current meal plans, and you can choose between weekly or monthly subscriptions."
              }
            },
            {
              "@type": "Question",
              "name": "Is the menu fixed for the entire month?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "No, we have a rotating menu to ensure variety while maintaining the homemade quality and health standards our customers love."
              }
            }
          ]
        })}
      </script>
    </>

  );
}

export default MealSubscription
